<template>
  <div class="register">
    <!--导航部分-->
    <div class="nav" style="padding-bottom: 56px;">
      <van-nav-bar
              title="注册用户"
              fixed
              left-arrow
              @click-left="onClickLeft"
      />
    </div>
    <!--输入框-->
    <div>
      <van-cell-group>
        <van-field v-model="name" label="姓名" placeholder="请输入姓名" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="phone" label="手机号" placeholder="请输入手机号" />
      </van-cell-group>
      <van-cell-group>
        <van-field v-model="password" label="密码" placeholder="请输入密码" />
      </van-cell-group>
    </div>
    <div style="width: 80%; margin:10px auto 0 auto;">
      <van-button type="primary" block @click="setLogin">登录</van-button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
    'name': 'Register',
    data() {
        return {
            name: '',
            phone: '',
            password: ''
        };
    },
    // 组件内守卫
    beforeRouteEnter:(to,from,next) => {
        if (localStorage.getItem('access_token')){
            next(vm => vm.$router.push({path:'/home'}));
        }else{
            next();
        }
    },
    methods: {
        ...mapActions(['requestRegister']),
        onClickLeft() {
            this.$router.push({path: '/login'});
        },
        setLogin() {
            return this.$toast('正在开发中...')
            // 注册提示，组装数据区
            /*const registerToast = this.$toast.loading({
                mask: true,
                message: '正在注册...',
                duration:0
            });
            let data = {
                name: this.name,
                phone: this.phone,
                password: this.password
            }
            // vuex 处理逻辑
            this.requestRegister({"data":data,"thit":this,"registerToast":registerToast});*/
        }
    }
};
</script>

<style scoped>
.register >>> .van-nav-bar {
  z-index: 9;
  background-color: #ff8917;
  padding-top: 6px;
}
.register >>> .van-nav-bar__text {
  color: #fff;
}
.register >>> .van-nav-bar__title {
  color: #fff;
}
.register >>> .van-nav-bar .van-icon {
  color: #fff;
}
.register >>> .van-button--primary {
  color: #fff;
  background-color: #ff8917;
  border: 0.02667rem solid #ff8917;
}
</style>
